import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FcGoogle } from 'react-icons/fc';
import { useGoogleLogin } from '@react-oauth/google';
import { useContextHook } from 'use-context-hook';
import OnboardingTemplate from '../OnboardingTemplate';
import { HeaderLink } from '../Onboarding/FlowTemplate/FlowTemplate.styles';
import { AuthFooterLink, AuthFormShell, AuthForgotLink } from '../Onboarding/AuthForm.styles';
import Form, { useForm } from '../../molecules/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import { AuthContext } from '../../../Context/authContext';

function Login() {
  const [form] = useForm();
  const navigate = useNavigate();

  const { onLogin, loading_user, onGoogleLogin, loading_user_google } = useContextHook(AuthContext, v => ({
    onLogin: v.onLogin,
    loading_user: v.loading_user,
    onGoogleLogin: v.onGoogleLogin,
    loading_user_google: v.loading_user_google,
  }));

  const handleSubmit = e => {
    onLogin(
      {
        email: e?.email,
        password: e?.password,
      },
      navigate,
    );
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async tokenResponse => {
      const { access_token } = tokenResponse;
      onGoogleLogin({ access_token, action: 'Login' });
    },
  });

  return (
    <OnboardingTemplate
      headerExtra={
        <HeaderLink>
          Don&apos;t have an account? <Link to="/sign-up">Sign up</Link>
        </HeaderLink>
      }>
      <AuthFormShell>
        <div className="auth-heading">
          <h1>
            <span className="gradient-text">Welcome</span> back.
          </h1>
          <p>Log in to power up your outreach with AI precision.</p>
        </div>

        <Form form={form} onSubmit={handleSubmit}>
          <Form.Item
            label="Email"
            type="email"
            name="email"
            placeholder="Enter your email address"
            rules={[{ required: true, message: 'Email is required' }]}>
            <Field />
          </Form.Item>

          <Form.Item
            label="Password"
            type="password"
            name="password"
            placeholder="Enter password"
            rules={[{ required: true, message: 'Password is required' }]}>
            <Field />
          </Form.Item>

          <AuthForgotLink to="/forgot-password">Forgot password?</AuthForgotLink>

          <div className="btn-holder">
            <Button rounded loader={loading_user} disabled={loading_user} variant="onboarding-gradient">
              Sign in
            </Button>
          </div>

          <div className="seprator">
            <span className="text">or</span>
          </div>

          <button type="button" className="googleAuth" onClick={googleLogin} disabled={loading_user_google}>
            <div className="img-holder">
              <FcGoogle />
            </div>
            Continue with Google
          </button>
        </Form>

        <AuthFooterLink>
          Don&apos;t have an account? <Link to="/sign-up">Sign up</Link>
        </AuthFooterLink>
      </AuthFormShell>
    </OnboardingTemplate>
  );
}

export default Login;
